/**
 *
 * TimeSlotResultStep
 *
 */

import {Component} from "react";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import GlobalMessages from "messages/messages";
import {
  getResultAction,
  getResultFailedAction,
  getResultSuccessAction,
  planAvailability,
} from "containers/TimeSlotPlanner/actions";
import {
  makeSelectActivity,
  makeSelectResult,
  makeSelectResultFailed,
  makeSelectResultLoading
} from "containers/TimeSlotPlanner/selectors";
import LoadingAnimation from "basicComponents/LoadingAnimation/LoadingAnimation";
import StepArrows from "components/MultiStep/StepArrows";
import ResultPoller from "./resultPoller";
import ConclusionPage from "../../ConclusionPage/ConclusionPage";
import {FormattedMessage} from "react-intl";

export class TimeSlotResultStep extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    activity: PropTypes.object.isRequired,
    getResultFailed: PropTypes.func.isRequired,
    getResultSuccess: PropTypes.func.isRequired,
    getResult: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    timeSlotId: PropTypes.number,
    result: PropTypes.any,
    resultFailed: PropTypes.any,
  };

  static defaultProps = {
    timeSlotId: -1,
  };

  state = {};

  componentDidMount() {
    this.resultPoller = new ResultPoller(
      this.props.getResultSuccess,
      this.props.getResultFailed,
      this.props.getResult,
    );
    this.getData();
  }

  getData() {
    return this.resultPoller.getData(
      this.props.activity,
      this.props.timeSlotId,
    );
  }

  render() {
    const done = !this.props.loading && this.props.result;

    const error = !this.props.loading && this.props.resultFailed;

    return (
      <StepArrows rightDisabled leftDisabled>
        {this.props.loading && <LoadingAnimation contained />}
        {error && (
          <FormattedMessage {...GlobalMessages.somethingWentWrong} />
        )}
        {done && (
          <ConclusionPage
            result={this.props.result}
            onContinue={this.props.onContinue}
          />
        )}
      </StepArrows>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  activity: makeSelectActivity(),
  result: makeSelectResult(),
  resultFailed: makeSelectResultFailed(),
  loading: makeSelectResultLoading(),
});

function mapDispatchToProps(dispatch) {
  return {
    getResult: () => dispatch(getResultAction()),
    getResultFailed: reason => dispatch(getResultFailedAction(reason)),
    getResultSuccess: result => dispatch(getResultSuccessAction(result)),
    planAvailability: (planning, timeSlotId) =>
      dispatch(planAvailability(planning, timeSlotId)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(TimeSlotResultStep);
